import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import EntityComponent from "../../common/entity-component";
import Snackbar from "../../common/Snackbar";

import config from "./config";
import UserForm from "./form";
import Store from "../../../types/Store";

import StoreUser from "../../../types/StoreUser";
import getAllHabits from "../../../database/habits/getAllHabits";
import ImportHabits from "./components/ImportHabits";
import { Habit } from "../../../types/Habit";
import { useHabitOperations } from "../../../database/habits/useHabit";

import {
  DesignSystemSurface,
  PageHeader,
} from "../../../design-system";
import { IconFlame } from "../../../design-system/icons/icons";

const Page = styled.div`
  min-height: calc(100vh - 104px);
  padding: var(--space-6) var(--space-6) var(--space-16);
`;

const PageInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

type Props = {
  getAllUsers: Function;
  createUser: Function;
  users: Array<Object>;
  removeUser: Function;
  editUser: Function;
  store: Store;
  user: StoreUser;
};

const HabitScreen = ({ user }: Props) => {
  let _passwordEdited = "";
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const { createHabit, editHabit, removeHabit } = useHabitOperations();
  const habitsResponse = getAllHabits({ communityId: user?.communityId });

  const onCreateHabit = async (habit: Habit) => {
    createHabit({ ...habit, communityId: user?.communityId });
  };

  const onRemoveUser = (habitId: string) => {
    removeHabit(habitId);
  };

  const onEditHabit = (habitEdited: Habit): void => {
    editHabit(habitEdited.id, habitEdited);
  };

  const onEditPassword = (newPassword: string): void => {
    _passwordEdited = newPassword;
  };

  const renderSnackbar = (response: any): React.ReactNode => {
    const { message, error } = response;
    return (
      <Snackbar
        onCloseSnackbar={() => setIsSnackbarOpen(false)}
        isOpen={isSnackbarOpen}
        message={message}
        error={error}
      />
    );
  };

  return (
    <DesignSystemSurface>
      <Page>
        <PageInner>
          <PageHeader
            title="Habits"
            subtitle="Recurring practices that anchor your plan content."
            actions={<ImportHabits communityId={user?.communityId} />}
          />
          <Fragment>
            <EntityComponent
              onRemoveItem={onRemoveUser}
              onCreateItem={onCreateHabit}
              onEditItem={onEditHabit}
              singularEntityName="Habit"
              pluralEntityName="Habits"
              filterConfig={config.filterConfig}
              tabConfig={config.tabConfig}
              dataset={habitsResponse.habits}
              canBeRemoved
              canBeCreated
              canBeEdited
              Form={(props) => (
                <UserForm onEditPassword={onEditPassword} {...props} />
              )}
            />
            {renderSnackbar(habitsResponse)}
          </Fragment>
        </PageInner>
      </Page>
    </DesignSystemSurface>
  );
};

const mapStateToProps = (state) => ({
  store: state.store,
  user: state.storeUser,
});

export default connect(mapStateToProps, null)(HabitScreen);
